import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-4" }

import { ref, watch } from "vue";
import ValidationErrors from "@/components/Common/ValidationErrors";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SalesforceIdForm',
  props: {
    salesforceId: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ["inputValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const localSalesforceId = ref("");

watch(
  () => props.salesforceId,
  () => {
    localSalesforceId.value = props.salesforceId;
  }
);

watch(localSalesforceId, () => {
  emits("inputValue", localSalesforceId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: __props.windowInnerWidth > 800 ? 2 : 3,
        class: "my-auto"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.salesforceId')), 1)
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: __props.windowInnerWidth > 800 ? 10 : 9
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: localSalesforceId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localSalesforceId).value = $event)),
            maxlength: "255",
            "error-messages": __props.errors?.salesforce_id
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _: 1
      }, 8, ["cols"])
    ]),
    _: 1
  }))
}
}

})